import Api from '~/services/Api'

export default class IpLocation {
  async getCountryCode() {
    try {
      const response = await new Api().get('https://ipinfo.io/json')
      return await Promise.resolve(response.country)
    } catch (e) {
      return await Promise.reject(e)
    }
  }
}
